<script>
import timeRenderer from '@/views/components/renderers/time-renderer.vue'

export default {
  components: {  
    timeRenderer
  },
  created() {
    
  },
  computed: {
    value() {
      return this.params.getValue();
    }
  }
};
</script>

<template>
  <time-renderer :value="value"></time-renderer>
</template>
